import React from 'react';

import { createPolymorphicComponent } from '@helpers/react/createPolymorphicComponent';

import { useSlideOutContext } from '../context/SlideOutContext';

interface Props {
  className?: string;
}

export const SlideOutCloseButton = createPolymorphicComponent<Props, 'button'>(
  ({ as: Component = 'button', innerRef, ...rest }) => {
    const { onClose } = useSlideOutContext();

    const onCloseWithReason = () => {
      onClose?.('closeButton');
    };

    return <Component ref={innerRef} onClick={onCloseWithReason} {...rest} />;
  }
);
